import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import { AdminUserLoginRedirectEnum, LoginModel } from 'src/app/models/auth/login';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SignalRService } from 'src/app/services/signal-rservice.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  loginObject: LoginModel = new LoginModel();

  loading = false;
  hidePassword = true;
  rememberMe = false;
  baseRoute = localStorage.getItem('baseRoute') || '/admin';

  returnUrl: string = '';

  errorMsg: any = null;
  captcha = '';
  formSubmitted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private signalRService: SignalRService,
    private authenticationService: AuthenticationService
  ) {
    // this.signalRService.stopConnection();
    if (this.route.snapshot.routeConfig?.path === 'logout') {
      this.authenticationService.logout();
      return;
    }
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate([this.baseRoute]);
    }
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.baseRoute;

    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(Patterns.email),
      ]),
      password: new FormControl('', CustomValidator.noWhiteSpace),
    });
  }

  login() {
    this.formSubmitted = true;
    this.errorMsg = null;

    const notNeedCaptcha = [
      'localhost:4200',
      'localhost:5000',
      'diwandev.expertapps.com.sa',
      'diwantest.expertapps.com.sa',
    ];
    if (notNeedCaptcha.includes(location.host)) {
      this.captcha = 'ay 7aga';
    }

    if (this.loginForm?.valid && this.captcha) {
      this.loading = true;
      this.authenticationService.login(
        this.loginForm.controls['email'].value,
        this.loginForm.controls['password'].value
      )
        .subscribe((data: any) => {
          this.loading = false;
          switch (data.loginRedirectEnum) {
            case AdminUserLoginRedirectEnum.Dashboard:
              this.baseRoute = '/admin/dashboard';
              break;
            case AdminUserLoginRedirectEnum.Profile:
              this.baseRoute = '/admin/profile';
              break;
            default:
              break;
          }
          localStorage.setItem('baseRoute', this.baseRoute);
          this.router.navigate([this.baseRoute]);
          location.reload();
        }, (error: any) => {
          this.loading = false;
          this.errorMsg = error;
        });
    }
  }

  public resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  hasError(controlName: string, errorName: string) {
    return this.loginForm?.controls[controlName].hasError(errorName);
  }
}
